import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LiftRideService {
  apiUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/Statistics';
  }

  getRides(params: HttpParams) {
    const url = this.apiUrl + '/GetNumberOfTrips';

    return this.httpClient.get<any>(url, { params: params });
  }
}
